import React from "react";
import { Stack } from "expo-router";
import { MobileHeader } from "@/screens/menu/mobile.header";
import { useMobileBreakpoint } from "@/utils/useMobileBreakpoint";

export default function QRsLayout() {
  const breakpoint = useMobileBreakpoint();

  return (
    <MobileHeader>
      <Stack.Screen
        name="index"
        options={{ title: "QR codes", headerShown: breakpoint === "mobile" }}
      />
    </MobileHeader>
  );
}
